/**
 * PreviewAngebot — Angebot (offers/pricing) content page
 */

interface PreviewAngebotProps {
  settings: {
    pageAngebot?: {
      sections?: Record<string, boolean>;
      heroTitle?: string;
      heroSubtitle?: string;
      packages?: Array<{
        name?: string;
        price?: string;
        description?: string;
        features?: string;
        highlighted?: boolean;
        ctaText?: string;
      }>;
      ctaTitle?: string;
      ctaText?: string;
      ctaButtonText?: string;
    };
    [key: string]: any;
  };
  components: any;
}
export function PreviewAngebot({ settings, components }: PreviewAngebotProps) {
  const page = settings.pageAngebot || {};
  const sec = page.sections || {};
  const packages = page.packages || [];

  return (
    <div className="content-page">
      <div className="preview-container">
        <section className="content-page__hero">
          <h1>{page.heroTitle || "Unsere Angebote"}</h1>
          <p>{page.heroSubtitle || ""}</p>
        </section>

        {sec.packages !== false && (
          <section className="pricing-grid">
            {packages.map((pkg, i) => {
              const features = (pkg.features || "").split(",").map(f => f.trim()).filter(Boolean);
              return (
                <div key={i} className={`pricing-card${pkg.highlighted ? " pricing-card--highlighted" : ""}`}>
                  <div className="pricing-card__name">{pkg.name}</div>
                  <div className="pricing-card__price">{pkg.price}</div>
                  <p className="pricing-card__description">{pkg.description}</p>
                  <ul className="pricing-card__features">
                    {features.map((f, fi) => <li key={fi}>{f}</li>)}
                  </ul>
                  <button className="btn btn--primary">{pkg.ctaText || "Anfragen"}</button>
                </div>
              );
            })}
          </section>
        )}

        {sec.cta !== false && page.ctaTitle && (
          <section className="page-cta">
            <h2>{page.ctaTitle}</h2>
            <p>{page.ctaText || ""}</p>
            <button className="btn btn--primary">{page.ctaButtonText || "Anfragen"}</button>
          </section>
        )}
      </div>
    </div>
  );
}
